import { fromJS } from 'immutable';

export default {
    setCommercialAgents: (state, commercialAgents) => {
        return state.setIn(['list'], fromJS(commercialAgents)).set('initialized', true);
    },
    setCommercialAgentDetails: (state, commercialAgent) => {
        return state.mergeIn(['list'], fromJS(commercialAgent));
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/CommercialAgents/core.js